const rawHubUrl =
  process.env.REACT_APP_JEM_HUB_URL || "https://hub.jemhr.online";
// Normalise: no trailing slash, so deepLink can concatenate paths cleanly.
export const NEW_HUB_URL = rawHubUrl.replace(/\/+$/, "");

// Livestorm registrations for the Jem Hub training webinar series. Each session
// is a separate Livestorm occurrence, hence one URL per date.
export interface WebinarSession {
  /** Human date shown in brackets after the link text. */
  label: string;
  url: string;
}

export const WEBINAR_SESSIONS: WebinarSession[] = [
  {
    label: "Tues, 11 August 2026",
    url: "https://app.livestorm.co/jem-hr/jem-hub-training?s=834e48b7-df76-41cc-97d6-5bdb7fad5dab",
  },
  {
    label: "Wed, 12 August 2026",
    url: "https://app.livestorm.co/jem-hr/jem-hub-training?s=89e9348a-8938-4709-982a-eb0e9f6ca81c",
  },
  {
    label: "Thurs, 13 August 2026",
    url: "https://app.livestorm.co/jem-hr/jem-hub-training?s=b493acd7-cb11-4691-8676-f101e8968bb2",
  },
];

export const EMPLOYER_READ_ONLY_CODE = "EMPLOYER_READ_ONLY";
export const BACKEND_READ_ONLY_CODE = "employer_read_only";
export const READ_ONLY_TOAST_COPY =
  "This dashboard is view-only — use the new Jem Hub.";
